<template>
  <v-timeline v-if="process.lines" dense v-bind="$attrs">
    <v-timeline-item
      small
      v-for="(line) in process.lines"
      :color="getTimelineColor(line.level)"
      :key="line.timestamp"
      left
      :icon="getTimelineIcon(line)"
    >
      <v-card class="elevation-2" shaped>
        <v-card-title class="headline">
          <i v-text="line.level" class="pr-2" :class="getTimelineColor(line.level)+ '--text'" />
          <p v-text="line.msg" />
        </v-card-title>
        <v-card-text>
          <span style="font-family:Consolas,Ubuntu Mono" v-html="line.className" />
          <br />
          <span>
            <b v-text="line.timestamp" />
          </span>
        </v-card-text>
        <v-card-actions v-if="line.details">
          <v-expansion-panels class="mx-4">
            <v-expansion-panel>
              <v-expansion-panel-header v-text="$t('monitoring.details.details')" />
              <v-expansion-panel-content>
                <Details :details="line.details" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-actions>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>
<script>
import Details from './Details.vue'

export default {
  name: 'Timeline',

  components: { Details },

  props: {
    process: {
      type: Object,
      required: true
    }
  },

  methods: {
    getTimelineColor (level) {
      const colors = {
        INFO: 'primary',
        ERROR: 'red',
        WARN: 'yellow',
        DEBUG: 'blue-grey'
      }
      return colors[level] || 'black'
    },

    getTimelineIcon (line) {
      return (line === true) ? 'mdi-format-text-wrapping-overflow' : ''
    }
  }

}
</script>
<style scoped>
p {
  margin: 0 !important
}
.methodname {
  color: brown;
  font-weight: bold;
}

.classname {
  color: blue;
}
</style>
